import React from 'react'
import { connect } from 'react-redux';
import styled from 'react-emotion';
import Link, { withPrefix } from 'gatsby-link';
import {Collapse} from 'react-collapse';

//  Components
import ThemeList from '../ThemeList/ThemeList.js'
import iconMenuUrl, { ReactComponent as IconMenu } from '../../assets/svg/icon-menu.svg'
import iconCloseUrl, { ReactComponent as IconClose } from '../../assets/svg/icon-close.svg'
import iconArrowUrl, { ReactComponent as IconArrow } from '../../assets/svg/icon-arrow.svg'
import { toggleDrawer as toggleDrawerAction } from '../../state/app';

//  Styles
import styles from './Navigation.module.scss'

class Navigation extends React.Component {

  state = {
    isTrendsShown: true,
    isStatesShown: false,
    isAlphabetical: false,
  };

  handleTrendsClick(e) {
    this.setState({ isTrendsShown: !this.state.isTrendsShown });
    e.preventDefault();
  }

  handleStatesClick(e) {
    this.setState({ isStatesShown: !this.state.isStatesShown })
    e.preventDefault();
  }

  handleOrderChange(e) {
    this.setState({ isAlphabetical: e.target.value === "Alphabetical" ? true : false })
    e.preventDefault();
  }

  render() {

    const { isDrawerOpen, toggleDrawer, themes, states } = this.props;
    const isTrendsShown = this.state.isTrendsShown;
    const isStatesShown = this.state.isStatesShown;
    const isAlphabetical = this.state.isAlphabetical;

    return (
      <div>
        <div className={ styles.menu_toggle }>
          <button className={isDrawerOpen ? styles.menu__open : styles.menu__closed}
          onClick={() => toggleDrawer(!isDrawerOpen)}
          >
            <IconMenu className={isDrawerOpen ? styles.icon__hidden : styles.icon__shown} />
            <IconClose className={!isDrawerOpen ? styles.icon__hidden : styles.icon__shown} />
            <strong>Menu</strong></button>
        </div>
        <div className={ [styles.menu, isDrawerOpen ? styles.menu__open : styles.menu__closed].join(' ') }>
          <button className={ styles.menu__close__icon } onClick={() => toggleDrawer(!isDrawerOpen)}>
            <IconClose />
          </button>
          <ul className={ styles.menu__primary }>
            <li>
              <Link exact to="/" onClick={() => toggleDrawer(!isDrawerOpen)} className={ styles.menu__primary__link } activeClassName={ styles.menu__primary__link__active }>Overview</Link>
            </li>
            <li>
              <h3 className={ `${styles.menu__secondary__title} ${styles.menu__secondary__title__spaced}` }>
                <button className={[
                  styles.menu__secondary__toggle, isTrendsShown ? styles.menu__secondary__toggle__open : 
                  styles.menu__secondary__toggle__closed
                  ].join(" ") } onClick={(e) => this.handleTrendsClick(e) }>
                  Trends <IconArrow />
                </button>
              </h3>
              <Collapse isOpened={isTrendsShown}>
                <ThemeList themes={ themes } className={ styles.menu__secondary } linkClassName={ styles.menu__secondary__link } activeClassName={ styles.menu__secondary__link__active } onLinkClick={() => toggleDrawer(!isDrawerOpen)} />
              </Collapse>
            </li>
            <li><Link exact to="/highlights" onClick={() => toggleDrawer(!isDrawerOpen)} className={ styles.menu__primary__link } activeClassName={ styles.menu__primary__link__active }>Highlights</Link></li>
            <li>
              <h3 className={ styles.menu__secondary__title }>
                <button className={[
                  styles.menu__secondary__toggle,
                  isStatesShown ? 
                  styles.menu__secondary__toggle__open :
                  styles.menu__secondary__toggle__closed
                  ].join(" ") } onClick={(e) => this.handleStatesClick(e) }>
                    States <IconArrow />
                  </button>
              </h3>
              <Collapse isOpened={isStatesShown}>
                <div className={styles.states__sorting__options}>
                  <label htmlFor="state--sort-select">Sort States:</label>
                  <select
                    id="state--sort-select"
                    value={isAlphabetical ? "Alphabetical" : "Ranking"}
                    className="select__small select__small__dark" onChange={(e) => this.handleOrderChange(e) }>
                    <option value="Alphabetical">Alphabetical</option>
                    <option value="Ranking">Ranking</option>
                  </select>
                </div>
                <ul className={ [
                  styles.menu__secondary,
                  styles.menu__states].join(" ")}>
                  { states.sort(
                    isAlphabetical ?
                      function(a, b){
                        return a.node.title == b.node.title ? 0 : +(a.node.title > b.node.title) || -1;
                      }
                    :
                      function(a, b) {
                        return a.node.ranking - b.node.ranking;
                      }
                  ).map((node, index) =>
                    <li key={ node.node.id }>
                      <Link
                        to={ `/state/${ node.node.url }` }
                        onClick={() => toggleDrawer(!isDrawerOpen) }
                        className={ [styles.menu__secondary__link, styles.menu__states__link].join(" ") }
                        activeClassName={ styles.menu__secondary__link__active }>
                          <strong>{ node.node.ranking }</strong>{ node.node.title }
                      </Link>
                    </li>
                  )}
                </ul>
              </Collapse>
            </li>
            <li><Link exact to="/conclusion" onClick={() => toggleDrawer(!isDrawerOpen)} className={ styles.menu__primary__link } activeClassName={ styles.menu__primary__link__active }>Conclusion</Link></li>
            <li><Link exact to="/methodology" onClick={() => toggleDrawer(!isDrawerOpen)} className={ styles.menu__primary__link } activeClassName={ styles.menu__primary__link__active }>Methodology</Link></li>
            <li><a href={ withPrefix(`/files/Radley_State_Scorecard_2018.pdf`)} onClick={() => toggleDrawer(!isDrawerOpen)} className={ styles.menu__primary__link }>PDF Download</a></li>
            <li><a href="http://datacenter.commonwealthfund.org" className={ styles.menu__primary__link }>Data Center</a></li>
          </ul>
        </div>
        <div
          className={ [styles.menu__cover, isDrawerOpen ? styles.menu__open : styles.menu__closed].join(' ') }
          onClick={() => toggleDrawer(!isDrawerOpen)} ></div>
      </div>
    )
  }
}

export default connect(
  state => ({ isDrawerOpen: state.app.isDrawerOpen }),
  dispatch => ({ toggleDrawer: open => dispatch(toggleDrawerAction(open)) }),
)(Navigation);


// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js